import React from 'react'
import PropTypes from 'prop-types'
import AdvertiserTypeSymbol from 'components/AdListItem/ListItem/AdvertiserTypeSymbol'
import Region from 'components/AdListItem/ListItem/Region'
import ListImage from '../ListImage'

import {
  Wrapper,
  Article,
  Content,
  ContentTop,
  SubjectSymbol,
  InfoWrapper,
  ImageWrapper,
  BodyWrapper,
  TitleWrapper,
  Title,
  BodyText,
  ToplistingLabel,
  LinkWrapper,
} from '../styled'

function PlacementItem({ ad, url, isExternalLink, onClick, imageSrc }) {
  return (
    <Wrapper to={url} external={isExternalLink} onClick={onClick}>
      <Article>
        <ImageWrapper>
          <ListImage src={imageSrc} alt={ad.subject} />
        </ImageWrapper>
        <Content>
          <ContentTop>
            <SubjectSymbol>
              <AdvertiserTypeSymbol
                advertiserType={ad.advertiser.type}
                parameterGroups={ad.parameterGroups}
              />
            </SubjectSymbol>
            <InfoWrapper>{ad.location && <Region adListItem={ad} />}</InfoWrapper>
            {ad.toplistingLabel && <ToplistingLabel>{ad.toplistingLabel}</ToplistingLabel>}
          </ContentTop>
          <TitleWrapper>
            <Title to={url}>{ad.subject}</Title>
          </TitleWrapper>
          <BodyWrapper>
            <BodyText>{ad.content}</BodyText>
          </BodyWrapper>
          <LinkWrapper>{ad.cta}</LinkWrapper>
        </Content>
      </Article>
    </Wrapper>
  )
}

PlacementItem.propTypes = {
  ad: PropTypes.object.isRequired,
  imageSrc: PropTypes.string,
  url: PropTypes.string.isRequired,
  isExternalLink: PropTypes.bool,
  onClick: PropTypes.func,
}

export default PlacementItem
